<template>
    <div id="description-mongolia-01">
        <div class="header">
            <div class="arrow-down text-center">
                <img :src="arrowDown" alt="arrowDown" @click="clickScroll">
            </div>
        </div>

        <p id="title-description" class="title-description">
            Did you know<br/>
            that we are<br/>
            always <span class="text-color">on the move</span><br/>
            but still <span class="text-color">welcome</span><br/>
            <span class="text-color">everyone into <br/>
            our communities</span>?
        </p>

        <div class="description">
            <p>The world is changing around us but we have always managed to stay true to our millennia-old nomadic lifestyle. Over a third of Mongolia people are still nomadic herders.</p>
            <p>Growing trends and shifts toward sustainability and community-based tourism makes Mongolia the ideal destination for travellers who seek just that. Through locally-led tours, visitors can discover the natural beauty, delicious food, exciting festivals and immerse themselves in the cultural heritage of local communities.</p>
        </div>
        <IG />
        <div class="arrow">
            <div class="text-left">
                <router-link to="/about-mongolia">
                    <img :src="arrowLeft" alt="arrowLeft">
                </router-link>
            </div>
            <div class="text-right">
                <router-link to="/description-mongolia-02">
                    <img :src="arrowRight" alt="arrowRight">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import arrowDown from '../../assets/img/arrow-down.png'
import arrowLeft from '../../assets/img/arrow-left.png'
import arrowRight from '../../assets/img/arrow-right.png'
import IG from '@/components/FirstIG'
import { TweenLite } from "gsap/all"

export default {
    name: 'description-mongolia-01',
    components: {
        IG
    },
    data() {
        return {
            arrowDown: arrowDown,
            arrowLeft : arrowLeft,
            arrowRight : arrowRight
        }
    },
    methods: {
        clickScroll() {
            TweenLite.to(window, .6, {scrollTo:{y:"#title-description", offsetY:60}});
        }
    }
}
</script>

<style lang="scss" scoped>
    #description-mongolia-01 {
        .header {
            height: 370px;
            background-image: url('../../assets/img/bg-description-01.png');
            background-size: cover;
            background-repeat: no-repeat;
            position: relative;

            .arrow-down {
                position: absolute;
                bottom: 17px;
                width: 100%;
            }
        }

        .title-description {
            color: #2C2C2C;
            font-size: 30px;
            font-weight: bold;
            padding:0px 20px;
            margin: 30px 0px;
        }

        .text-color {
            color: #911457;
        }

        .description {
            padding:0px 20px;
        }

        .arrow {
            display: flex;
            padding: 60px 0 30px;
            div {
                width: 50%;
            }
        }
    }
</style>


